var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('v-container', [_c('div', {
    staticClass: "tit-wrap text-center"
  }, [_c('h2', {
    staticClass: "tit tit--lg"
  }, [_vm._v("About & Mission")])]), _c('div', {
    staticClass: "page-section-wrap"
  }, [_c('section', {
    staticClass: "page-section"
  }, [_c('div', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("수수료는 낮추고, 작품가치는 올리고")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("아름다운 작품, 소중한 작품을 소장한다는 것은 참으로 기쁜 일입니다.")])]), _c('div', {
    staticClass: "page-text"
  }, [_c('p', [_vm._v("작품을 통하여 심리적 안정과 만족감을 느끼고, 가정의 행복과 회사 성장에 기여할 수도 있습니다. 저희는 고객 한 분, 한 분마다 좋은 작품을 소장하면서, 이러한 안정·만족·행복·성장이 함께 하시길 진심으로 바랍니다.")]), _c('p', [_vm._v("한국인이 운영하는 미술품 경매는 1920년대에 시작되었다고 합니다. 식민지 국가의 영세한 경매소 수준이었던 나라에서, 100년이 지난 지금은, 괄목상대할 정도로 성장한 것이 놀랍습니다. 국가 경제력만큼 고도 성장한 경매시장의 성장 이면(裏面)에는 높은 수수료, 아쉬운 작품 분석력, 도록 및 인건비의 부담, 매뉴얼 및 시스템의 미완성 등 여러 가지 과제도 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("남아 있습니다.")]), _c('p', [_vm._v("캐터옥션은 이러한 과제를 해결하며, 고객 선택의 폭을 넓히기 위하여, 아래와 같이, 고객 서비스를 좀 더 세분화, 차별화하고자 합니다."), _c('br'), _vm._v("이를 통하여, 한국미술시장의 질적인 지속 성장에 일조를 하고자 합니다.")])])])], 1)], 1)]), _c('v-divider', {
    staticClass: "grey-cb"
  }), _c('section', {
    staticClass: "page-section"
  }, [_c('div', {
    staticClass: "mb-20 mb-md-30"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("미션 (Our Mission)")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('h3', {
    staticClass: "tit tit--sm line-height-14"
  }, [_vm._v("폭포는 영어로 Cataract입니다. Cata(Kata)는 ‘밑으로’, "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("‘낮추다’ 라는 뜻입니다."), _c('br'), _vm._v("KATA 옥션은 ‘미술의 문턱’을 낮추고, ‘고객의 부담’도 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("낮추고자 합니다.")])])], 1)], 1), _c('div', {
    staticClass: "my-n14 my-md-n20"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('div', {
    staticClass: "h-100 py-4 py-md-6"
  }, [_c('div', {
    staticClass: "gallery-card d-flex flex-column h-100"
  }, [_c('div', {
    staticClass: "gallery-card__img-wrap"
  }, [_c('v-img', {
    staticClass: "grey-ef",
    attrs: {
      "aspect-ratio": 585 / 300,
      "src": "/images/sub/about/about-mission-img.png"
    }
  })], 1), _c('div', {
    staticClass: "gallery-card__con h-100 py-20 pt-lg-20 pb-lg-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("작품 가치의 발굴")])]), _c('div', [_c('ul', {
    staticClass: "letter-list"
  }, [_c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("그간, 작품에 대한 구체적인 의미나 내용보다는, 다소 애매하고 모호한 작가(作家) 설명으로 대체하곤 했습니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("캐터옥션은 출품하는 작품 그 자체에 집중하여 연구하며, 작품 내면의 다양의 가치 발굴에 노력할 것입니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("즉, 미술사적 연구방법론을 활용하여, 출품작품의 주제, 구도, 형태, 색채, 기법, 재질 등에 관한 형식분석과 양식분석을 실시합니다. 이를 통하여, 해당 작품의 미술사적 의의, 작품 속에서의 위치, 가치 등을 규명합니다.")])])])])]), _c('v-divider', {
    staticClass: "primary"
  })], 1)])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('div', {
    staticClass: "h-100 py-4 py-md-6"
  }, [_c('div', {
    staticClass: "gallery-card d-flex flex-column h-100"
  }, [_c('div', {
    staticClass: "gallery-card__img-wrap"
  }, [_c('v-img', {
    staticClass: "grey-ef",
    attrs: {
      "aspect-ratio": 585 / 300,
      "src": "/images/sub/about/about-mission-img2.png"
    }
  })], 1), _c('div', {
    staticClass: "gallery-card__con h-100 py-20 pt-lg-20 pb-lg-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("<진품성 보장> : 구매시 5종의 서류제공")])]), _c('div', [_c('ul', {
    staticClass: "letter-list"
  }, [_c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("<진품보증서>가 확보된 작품만 출품합니다. 따라서, 작품 구매시, <진품보증서>도 함께 전달됩니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("또한, 캐터옥션 명의의 <상태검사서>, <작품이력서>, <출품확인서>, <작품설명서>등 5가지 서류가 함께 전달됩니다. 이러한 검사분석 과정을 통하여, 신규 구입 작품에 대한 부가가치를 좀더 제고해 드립니다. ")])])])])]), _c('v-divider', {
    staticClass: "primary"
  })], 1)])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('div', {
    staticClass: "h-100 py-4 py-md-6"
  }, [_c('div', {
    staticClass: "gallery-card d-flex flex-column h-100"
  }, [_c('div', {
    staticClass: "gallery-card__img-wrap"
  }, [_c('v-img', {
    staticClass: "grey-ef",
    attrs: {
      "aspect-ratio": 585 / 300,
      "src": "/images/sub/about/about-mission-img3.png"
    }
  })], 1), _c('div', {
    staticClass: "gallery-card__con h-100 py-20 pt-lg-20 pb-lg-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("<시스템 관리> : 인적관리는 지양")])]), _c('div', [_c('ul', {
    staticClass: "letter-list"
  }, [_c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("캐터 옥션은, 고도의 경매업무 매뉴얼, 체계적인 관리시스템, 경매 동향 분석 및 연구자료 등을 통하여, ")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("<인적 관리> 보다는 <시스템 관리>를 통하여 신속하고, 다양한 고객만족을 드릴 것입니다.")])])])])]), _c('v-divider', {
    staticClass: "primary"
  })], 1)])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('div', {
    staticClass: "h-100 py-4 py-md-6"
  }, [_c('div', {
    staticClass: "gallery-card d-flex flex-column h-100"
  }, [_c('div', {
    staticClass: "gallery-card__img-wrap"
  }, [_c('v-img', {
    staticClass: "grey-ef",
    attrs: {
      "aspect-ratio": 585 / 300,
      "src": "/images/sub/about/about-mission-img4.png"
    }
  })], 1), _c('div', {
    staticClass: "gallery-card__con h-100 py-20 pt-lg-20 pb-lg-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("<낮은 수수료>")])]), _c('div', [_c('ul', {
    staticClass: "letter-list"
  }, [_c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("캐터옥션은 <경매>와 <프라이빗 세일>을 함께 진행합니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("<경매>와 <프라이빗 세일>의 위탁수수료 및 구매수수료는 5%입니다. ")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("고객 여러분의 경제적 부담을 낮춰 드리고, 작품의 가치는 올려 드립니다. ")])])])])]), _c('v-divider', {
    staticClass: "primary"
  })], 1)])])], 1)], 1)])], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }